import React from 'react';
import 'typeface-roboto';
import * as env from "dotenv";
import { Header } from './components/menus/Header';
import { Routers } from './components/Routers';
import ControleSessao from './components/ControleSessao';


const _PRODUCAO = 'PRODUCAO';

// carrega as configurações do .env
env.config();
if (process.env.APP_ENV === _PRODUCAO) {
  env.config({ path: './producao.env' });
}

const App: React.FC = () => {
 
  return (
    <div>
      <ControleSessao
       
        timeout={1000 * 60 * 1000}>
        <Header />
        <Routers />
      </ControleSessao>
    </div >
  );
}

export default App;
